import type { HomepageConfiguration } from '@rover/types/src/HomepageConfiguration';
import { fullApiUrl } from '@rover/utilities/apiUrl';

import safeGet from './GETWithErrorHandling';

export const homepageConfigurationUrl = fullApiUrl('frontend/homepage-configuration/');
export const GET_ERROR_MESSAGE = 'Something went wrong when fetching the homepage configuration';

export const get = async (): Promise<HomepageConfiguration | null> =>
  safeGet(homepageConfigurationUrl, GET_ERROR_MESSAGE, false);
